import { useMutation } from '@apollo/client';
import {
  CREATE_TMS_TASK_WAYPOINT_LOCATION_INFO,
  CreateTmsTaskWaypointLocationInfoInput
} from '../../../tms/graphql/mutations/createTmsTaskWaypointLocationInfo';
import { FirstPhotoWatermarkLocation } from '../../../../utils/appRuntime';

/**
 * 保存 TMS 任务途经点位置信息（首张照片水印经纬度、解析地址）
 * 失败不阻塞主流程，仅 console.warn
 */
export function useSaveTmsTaskWaypointLocationInfo() {
  const [createTmsTaskWaypointLocationInfo] = useMutation(CREATE_TMS_TASK_WAYPOINT_LOCATION_INFO);

  const save = async (
    taskId: number,
    taskWaypointId: number,
    nodeType: number,
    firstPhotoLocation?: FirstPhotoWatermarkLocation | null
  ): Promise<void> => {
    if (!firstPhotoLocation || (firstPhotoLocation.latitude == null && firstPhotoLocation.longitude == null)) {
      return;
    }
    try {
      const input: CreateTmsTaskWaypointLocationInfoInput = {
        taskId,
        taskWaypointId,
        nodeType,
        latitude: firstPhotoLocation.latitude ?? undefined,
        longitude: firstPhotoLocation.longitude ?? undefined,
        parsedAddress: firstPhotoLocation.parsedAddress ?? undefined
      };
      await createTmsTaskWaypointLocationInfo({ variables: { input } });
    } catch (e) {
      console.warn('写入首张照片位置信息失败:', e);
    }
  };

  return { save };
}
